
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/every-student-writing-10-minutes-without-grading-30-more-papers",
      function () {
        return require("private-next-pages/c/blog-posts/every-student-writing-10-minutes-without-grading-30-more-papers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/every-student-writing-10-minutes-without-grading-30-more-papers"])
      });
    }
  